import { render, staticRenderFns } from "./card-management.vue?vue&type=template&id=54ec7029&scoped=true"
import script from "./card-management.vue?vue&type=script&lang=js"
export * from "./card-management.vue?vue&type=script&lang=js"
import style0 from "./card-management.vue?vue&type=style&index=0&id=54ec7029&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec7029",
  null
  
)

export default component.exports